module.exports = __webpack_public_path__ + "static/media/can_logo_url_light.69accdec.svg";